import axios from 'axios';
import store from '../store';

const refreshPath = '/web-api/auth/refresh'

const refreshToken = async () => {
  const api_url = store.getters.GetConfig.API + refreshPath;

  try {
    // Token Refreshed
    // console.log('Token Refresh');
    const refreshResponse = await axios.get(api_url);
    const {token} = refreshResponse.data;
    await store.dispatch('SetLoggedIn', true);
    await store.dispatch('SetToken', {token: token});
    return false;
  } catch (e) {
    // Token Refresh Failed
    // console.log('Refresh Token Expired - Logging Out');
    await store.dispatch('SetLoggedIn', false);
    window.location.href = "/login";
    return e.message;
  }
};

// Request interceptor
axios.interceptors.request.use(function (config) {

  let urlData = {
    pathname: ''
  };

  try {
    urlData = new URL(config.url)
  } catch (e) {
    urlData.pathname = config.url
  }

  if (urlData.pathname === refreshPath) {
    config.headers.Authorization = 'Bearer ' + store.getters.GetRefreshToken;
  } else {
    config.headers.Authorization = 'Bearer ' + store.getters.GetToken;
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

// Response interceptor
axios.interceptors.response.use(function (response) {
  return response;
}, async function (error) {

  const originalConfig = error.config;

  let urlData = {
    pathname: originalConfig.url
  };

  try {
    urlData = new URL(originalConfig.url)
  } catch (e) {
    urlData.pathname = originalConfig.url
  }

  if (
    urlData.pathname !== '/web-api/auth/login' &&
    urlData.pathname !== '/web-api/auth/refresh' &&
    urlData.pathname !== '/web-api/auth/login/tfa' &&
    error.response
  ) {
    if (!originalConfig._retry) {
      originalConfig._retry = true;
      switch (error.response.status) {
        case 400:
          if (error.response.data.message === 'invalidToken') {
            const failed = await refreshToken();
            if (failed) {
              return Promise.reject(failed);
            } else {
              return axios.request(originalConfig);
            }
          }
          break;
        case 401:
          const failed = await refreshToken();
          if (failed) {
            return Promise.reject(failed);
          } else {
            return axios.request(originalConfig);
          }
        default:
          return Promise.reject(error);
      }
    } else {
      return Promise.reject(error);
    }
  } else {
    return Promise.reject(error);
  }
});


export default {
  install: function (Vue,) {
    Object.defineProperty(Vue.prototype, '$http', {value: axios});
  }
}
